export const navLinks = [
  { label: "Home", path: "/" },
  { label: "Chi siamo", path: "/chi-siamo" },
  { label: "Prodotti", path: "/prodotti" },
  { label: "Lavora con noi", path: "/lavora-con-noi" },
  { label: "Contatti", path: "/contatti" },
];

export const heroData = {
  title: "Oltre la finestra, il tuo orizzonte.",
  subtitle: "Sistemi esclusivi per vivere lo spazio senza confini.",
  image: "/media/204800-4e66e139-5ff7-43ef-a5f4-cf9b1ba6e874-0-1024x574.jpg",
};

export const features = [
  { title: "Falegnameria per tre generazioni", desc: "Un ponte tra generazioni, coltivando il gusto di combinare il rispetto per le conoscenze di base con un moderno processo di produzione." },
  { title: "Sostenibilità Ambientale", desc: "Utilizzando profili in PVC senza piombo e riciclando rifiuti di PVC e vetro contribuiamo alla protezione dell'ambiente." },
  { title: "Serramenti su Misura", desc: "Dalla produzione su misura alla produzione industriale, coniugando qualità e costi controllati." },
];

export const products = [
  {
    id: 1,
    slug: "schuco-living-82",
    title: "Schüco LivIng 82",
    description: "Sistema PVC a 7 camere con profondità costruttiva 82 mm: garantisce ottimo isolamento termico e acustico. Lavorato con macchinari di ultima generazione.",
    image: "/media/4043a30.jpg",
    details: {
      longDescription: "Schüco LivIng 82 è il nuovo sistema per finestra in PVC basato su una tecnologia a 7 camere, con profondità del telaio e dell’anta pari a 82mm. Stabilisce nuovi standard in termini di comfort, sicurezza, efficienza energetica e design. Le 7 camere all’interno del profilo assicurano il massimo isolamento termico fino al livello di una casa passiva.",
      features: [
        "Tecnologia a 7 camere con profondità 82 mm",
        "Tripla guarnizione (versione MD) per isolamento superiore",
        "Disponibile con telaio standard a L o telaio Z da restauro (alette da 50mm rifilabili)",
        "Spessore vetro alloggiabile da 28 mm a 52 mm",
        "Protezione efficace contro correnti d'aria, umidità e rumore",
        "Disponibile in colorazioni corpo Grigio, Caramello o Bianco"
      ],
      specs: [
        { label: "Profondità", value: "82 mm" },
        { label: "Camere interne", value: "7" },
        { label: "Isolamento Termico (Uf)", value: "da 0,96 a 1,0 W/(m²K)" },
        { label: "Isolamento Acustico", value: "da 34 a 47 dB" },
        { label: "Tenuta all'acqua", value: "Classe 9A" },
        { label: "Sicurezza", value: "Fino a RC2" }
      ]
    }
  },
  {
    id: 2,
    slug: "schuco-livingslide",
    title: "Schüco LivIngSlide",
    description: "Scorrevole alzante in PVC progettato per grandi superfici: assicura elevate prestazioni termo-acustiche, manovrabilità dolce e ante con portate importanti fino a centinaia di kg.",
    image: "/media/schueco-livingslide-ecolution-aussen-300dpi.jpg",
    details: {
      longDescription: "Ideale per le grandi superfici vetrate, Schüco LivIngSlide dona luce e libertà alla tua casa. Progettato per garantire la massima stabilità anche con ante di grandi dimensioni e portate fino a 400 kg. Ogni dettaglio è studiato per accompagnare il gesto dell'apertura con estrema leggerezza.",
      features: [
        "Ideale per grandi superfici vetrate",
        "Apertura fluida e manovrabilità dolce",
        "Elevato isolamento termico e acustico",
        "Sicurezza certificata contro i tentativi di effrazione",
        "Tenuta ermetica contro spifferi e infiltrazioni",
        "Soglia a taglio termico per il massimo comfort"
      ],
      specs: [
        { label: "Tipologia", value: "Scorrevole Alzante" },
        { label: "Portata massima anta", value: "fino a 400 kg" },
        { label: "Sicurezza", value: "fino a RC2" },
        { label: "Design", value: "Spazi luminosi e aperti" }
      ]
    }
  },
  {
    id: 3,
    slug: "schuco-livingslide-panorama",
    title: "Schüco LivIngSlide Panorama",
    description: "Versione «Panorama» con profili ancora più sottili per massimizzare la superficie vetrata e ottenere una continuità visiva tra interno ed esterno.",
    image: "/media/ambientazioni-schuco-pvc-300dpi.jpg",
    details: {
      longDescription: "La luce allo stato puro. La versione Panorama dello scorrevole LivIngSlide è concepita per ridurre al minimo l'impatto visivo dei profili. Il design minimal riduce le sezioni a vista e amplifica la percezione di spazio, creando una continuità visiva ininterrotta tra l'interno della casa e l'ambiente esterno.",
      features: [
        "Profili estremamente sottili per la massima luminosità",
        "Continuità visiva tra ambiente interno ed esterno",
        "Design ultra-minimalista",
        "Stesse prestazioni termiche e acustiche della versione standard",
        "Perfetto per l'architettura contemporanea"
      ],
      specs: [
        { label: "Tipologia", value: "Scorrevole Alzante Panoramico" },
        { label: "Sezioni in vista", value: "Ridotte al minimo" },
        { label: "Isolamento termico", value: "Standard elevatissimi" },
        { label: "Luminosità", value: "Massimizzata" }
      ]
    }
  },
  {
    id: 4,
    slug: "schuco-living-move",
    title: "Schüco LivIng Move",
    description: "Scorrevole in linea ad alte prestazioni che offre grande tenuta fino a classe 9A e ventilazione controllata tramite una sottilissima intercapedine (≈6 mm) tra anta e telaio.",
    image: "/media/schueco-comprislide-m-1.jpg",
    details: {
      longDescription: "Schüco LivIng Move rappresenta la versione più raffinata della tecnologia scorrevole in linea. Permette di ventilare gli ambienti in totale sicurezza anche a finestra chiusa, grazie a una sottile intercapedine di soli 6 mm tra anta e telaio. Questo garantisce un ricambio d'aria controllato senza subire forti dispersioni termiche, ideale per case moderne, uffici e scuole.",
      features: [
        "Tecnologia scorrevole in linea innovativa",
        "Ventilazione controllata e sicura a finestra chiusa",
        "Intercapedine per ricambio aria (circa 6 mm)",
        "Altissima tenuta all'acqua (fino a classe 9A)",
        "Nessuna dispersione termica durante la ventilazione sicura"
      ],
      specs: [
        { label: "Tipologia", value: "Scorrevole in linea" },
        { label: "Tenuta all'acqua", value: "fino a Classe 9A" },
        { label: "Intercapedine ventilazione", value: "≈ 6 mm" },
        { label: "Destinazione d'uso", value: "Abitazioni, scuole, uffici" }
      ]
    }
  },
  {
    id: 5,
    slug: "schuco-softslide-panorama",
    title: "Schüco SoftSlide Panorama",
    description: "Sistema scorrevole modulare che cancella i confini tra interno ed esterno: nodo centrale ridotto, ante grandi e possibilità di soglia senza barriere.",
    image: "/media/schueco-softslide-m-300dpi.jpg",
    details: {
      longDescription: "Schüco SoftSlide Panorama è la vetrata che cancella letteralmente i confini tra interno ed esterno. Grazie al nodo centrale estremamente ridotto e alle grandissime ante scorrevoli, la luce naturale diventa la protagonista assoluta degli spazi. Offre inoltre la possibilità di installare la soglia ribassata senza barriere, per un passaggio comodo e sicuro in ogni situazione.",
      features: [
        "Nodo centrale ridotto per viste ininterrotte",
        "Sistema modulare flessibile (2, 3, 4 o 6 ante)",
        "Opzione di soglia ribassata senza barriere architettoniche",
        "Alta permeabilità alla luce naturale",
        "Design elegante e contemporaneo"
      ],
      specs: [
        { label: "Tipologia", value: "Sistema Scorrevole Panoramico" },
        { label: "Modularità", value: "2, 3, 4 o 6 ante (fisse/mobili)" },
        { label: "Soglia", value: "Opzione Zero Barriere" },
        { label: "Nodo centrale", value: "Estremamente sottile" }
      ]
    }
  },
  {
    id: 6,
    slug: "schuco-focusing",
    title: "Schüco FocusIng",
    description: "Profilo 70/76 mm che unisce prestazioni termiche, design minimale e un’anima più sostenibile (nucleo con materiale riciclato), ideale per ristrutturazioni e nuove costruzioni.",
    image: "/media/ambientazione-schuco-focusing-4-.jpg",
    details: {
      longDescription: "Dalla fusione del rinomato sistema LivIng e il classico CT 70 nasce Schüco FocusIng, il profilo intelligente che coniuga efficienza termica elevata, profondità di telaio compatta, estetica moderna e un cuore green sostenibile (nucleo in PVC riciclato). Il risultato è una finestra solida, luminosa ed essenziale.",
      features: [
        "Profondità telaio compatta (70/76 mm)",
        "Nucleo sostenibile con materiale riciclato",
        "Disponibile con guarnizione doppia (AS) o tripla (MD)",
        "5/6 camere interne per un ottimo isolamento",
        "Sezioni in vista ridotte per maggiore luminosità",
        "Piena compatibilità con accessori LivIng"
      ],
      specs: [
        { label: "Profondità telaio", value: "70/76 mm" },
        { label: "Camere interne", value: "5 o 6" },
        { label: "Guarnizioni", value: "2 (AS) o 3 (MD) in SEBS" },
        { label: "Sostenibilità", value: "Nucleo in PVC riciclato" }
      ]
    }
  },
  {
    id: 7,
    slug: "schuco-topalu",
    title: "Schüco TopAlu",
    description: "Soluzione ibrida con PVC all’interno e coperture in alluminio esterno: unisce isolamento, facilità di manutenzione e ampia personalizzazione estetica.",
    image: "/media/schueco-topalu-300dpi.jpg",
    details: {
      longDescription: "Con Schüco TopAlu, il serramento raggiunge un nuovo livello di versatilità architettonica. Questa soluzione ibrida sfrutta l'eccellente isolamento termico del profilo in PVC all'interno, combinandolo con l'infinita personalizzazione estetica e la resistenza dell'alluminio all'esterno.",
      features: [
        "Sistema ibrido PVC (interno) e Alluminio (esterno)",
        "Eccellente isolamento termico garantito dal cuore in PVC",
        "Cover in alluminio esterna altamente resistente",
        "Infinita gamma di colorazioni RAL e finiture anodizzate per l'esterno",
        "Zero manutenzione e massima durabilità"
      ],
      specs: [
        { label: "Tipologia", value: "Sistema Ibrido PVC/Alluminio" },
        { label: "Interno", value: "PVC ad alte prestazioni" },
        { label: "Esterno", value: "Alluminio verniciabile/anodizzabile" },
        { label: "Resistenza", value: "Altissima agli agenti atmosferici" }
      ]
    }
  },
  {
    id: 8,
    slug: "schuco-corona-ct-70",
    title: "Schüco Corona CT 70",
    description: "Sistema in PVC a 5 camere per finestre e porte, perfetto per nuove costruzioni e progetti di ristrutturazione. Affidabilità e sicurezza garantite.",
    image: "/media/2361a11-300dpi.jpg",
    details: {
      longDescription: "Il sistema Schüco Corona CT 70 in PVC si basa su una tecnologia a 5 camere altamente affidabile. È una soluzione estremamente versatile, adatta sia per progetti di nuova costruzione che per progetti di ristrutturazione. L'ampia gamma di accessori garantisce un elevato livello di sicurezza e personalizzazione del sistema.",
      features: [
        "Tecnologia a 5 camere isolanti",
        "Ideale per nuove costruzioni e ristrutturazioni",
        "Soglia in materiale composito plastica/alluminio da 20 mm",
        "Serrature con azionamento sia dalla maniglia che dalla chiave",
        "Disponibile nei colori corpo Grigio e Bianco",
        "Spessori del pacchetto vetro: 24/28/32/40 mm"
      ],
      specs: [
        { label: "Tipologia", value: "Sistema a 5 camere" },
        { label: "Profondità", value: "70 mm" },
        { label: "Spessore Vetro", value: "Fino a 40 mm" },
        { label: "Soglia", value: "20 mm a taglio termico" }
      ]
    }
  },
  {
    id: 9,
    slug: "schuco-variotec-advanced",
    title: "Schüco VarioTec Advanced",
    description: "Ferramenta modulare e robusta per finestre Schüco: maggiore portata, scorrimento fluido, opzioni di sicurezza e finiture dedicate.",
    image: "/products/schuco-variotec-advanced.jpeg",
    details: {
      longDescription: "La ferramenta Schüco VarioTec Advanced è il cuore nascosto di ogni finestra Schüco. Sicura, fluida e invisibile, garantisce un funzionamento impeccabile nel tempo. Combina i vantaggi della tradizionale ferramenta in acciaio con il principio di chiusura a nastro tipico dell'alluminio.",
      features: [
        "Apertura e chiusura estremamente fluida",
        "Design nascosto e integrato nel profilo",
        "Elevata resistenza alla corrosione e all'usura",
        "Nottolini a fungo per una sicurezza antieffrazione superiore",
        "Maniglie personalizzabili con chiave o pulsante di blocco",
        "Maggiore portata per vetraggi pesanti"
      ],
      specs: [
        { label: "Prodotto", value: "Ferramenta Meccanica Avanzata" },
        { label: "Materiale", value: "Acciaio e componenti ibridi" },
        { label: "Sicurezza", value: "Antieffrazione modulare" },
        { label: "Design", value: "Invisibile e minimale" }
      ]
    }
  },
  {
    id: 10,
    slug: "schuco-bluecon-i",
    title: "Schüco BlueCon i",
    description: "Sistema di accesso Bluetooth per porte: gestione via app, autorizzazioni personalizzabili e sblocco automatico per un accesso smart e sicuro.",
    image: "/media/bluecon-m-vernetzung-bluetooth.jpg",
    details: {
      longDescription: "Con Schüco BlueCon i, la tua porta d'ingresso diventa un dispositivo intelligente. Questo modulo integrato invisibile permette l'accesso keyless tramite il tuo smartphone via Bluetooth. L'app dedicata consente di gestire autorizzazioni temporanee o permanenti, monitorare gli accessi e attivare lo sblocco automatico all'avvicinamento.",
      features: [
        "Apertura della porta senza chiavi tramite Bluetooth",
        "Integrazione invisibile e design minimalista",
        "Sblocco automatico (Auto-Unlock) avvicinandosi alla porta",
        "Gestione facile degli accessi tramite App dedicata",
        "Creazione di chiavi digitali temporanee per ospiti o collaboratori",
        "Sicurezza digitale con doppia crittografia AES a 256 bit"
      ],
      specs: [
        { label: "Tecnologia", value: "Bluetooth Low Energy" },
        { label: "Controllo", value: "App Smartphone (iOS / Android)" },
        { label: "Sicurezza", value: "Crittografia AES 256-bit" },
        { label: "Installazione", value: "Plug & Play a scomparsa" }
      ]
    }
  }
];